module.exports = __webpack_public_path__ + "media/BNP_Samodzielniak_25_E_6.32f0a300.mp3";